// extracted by mini-css-extract-plugin
export var infoCard = "Card-module--info-card--3nH8K";
export var infoCardActive = "Card-module--info-card--active--29Wlt";